export default __webpack_public_path__ + "static/media/element_70.1db07f5f.webp";